import autoTable from 'jspdf-autotable';
import jsonTableRow from './rows';

// HELPERS
import title from '../../../../helpers/title';

// UTILS
import arrayTo2DArrayUTL from '../../../../../../utils/arrayTo2DArrayUTL';

const dataSourceVerificationResults = (doc, data, info, docStyles) => {
  const { Response } = data;

  // TITLE
  title(
    doc,
    docStyles,
    'Summary of Data Source Verifications and Results',
    docStyles.headers.secondary,
    docStyles.separation
  );

  // DEFAULT COLUMN
  const columns = [{ title: 'Data Sources', dataKey: 'col1' }];

  // DATA SOURCES RESULTS
  let driversLicence = Response.serviceResponses['India Drivers Licence'];
  let pan = Response.serviceResponses['India PAN'];
  let epic = Response.serviceResponses['India EPIC'];
  let passport = Response.serviceResponses['India Passport'];
  let aadhaarNo = Response.serviceResponses['India Aadhaar'];
  let watchlistAML = Response.serviceResponses['Watchlist AML'];

  // INDIA DRIVERS LICENCE
  if (driversLicence) {
    columns.push({
      title: 'India Drivers Licence',
      dataKey: 'col2',
    });
  } else {
    driversLicence = { verifications: {}, returnedData: {} };
  }

  // INDIA PAN
  if (pan) {
    columns.push({
      title: 'India PAN',
      dataKey: 'col3',
    });
  } else {
    pan = { verifications: {}, returnedData: {} };
  }

  // INDIA EPIC
  if (epic) {
    columns.push({
      title: 'India EPIC',
      dataKey: 'col4',
    });
  } else {
    epic = { verifications: {}, returnedData: {} };
  }

  // INDIA PASSPORT
  if (passport) {
    columns.push({
      title: 'India Passport',
      dataKey: 'col5',
    });
  } else {
    passport = { verifications: {}, returnedData: {} };
  }

  // INDIA Aadhaar
  if (aadhaarNo) {
    columns.push({
      title: 'India Aadhaar',
      dataKey: 'col5',
    });
  } else {
    aadhaarNo = { verifications: {}, returnedData: {} };
  }

  // GLOBAL WATCHLIST AML
  if (watchlistAML) {
    columns.push({
      title: 'Global Watchlist AML',
      dataKey: 'col6',
    });
  } else {
    watchlistAML = { verifications: {}, returnedData: {} };
  }

  // TABLE ROW
  const rows = jsonTableRow({
    driversLicence,
    pan,
    epic,
    passport,
    watchlistAML,
  });

  // TABLE

  // let finalY = (doc.lastAutoTable.finalY || 40) + docStyles?.tableYFromTitle;
  let finalY = (doc.lastAutoTable.finalY || 40) + docStyles?.tableYFromTitle;
  const maxAmountOfColumns = 3;
  const firstColumn = columns.shift();
  const maxColArray = arrayTo2DArrayUTL(columns, maxAmountOfColumns); // 3 COLUMNS ONLY

  maxColArray.map((col, index) => {
    col.unshift(firstColumn);

    if (index > 0) {
      finalY = (doc.lastAutoTable.finalY || 40) + docStyles.separation;
    }

    let cellWidth = docStyles.fullCellLength / 4;
    if (maxColArray[index].length === 4) {
      cellWidth = docStyles.fullCellLength / 4;
    } else if (maxColArray[index].length === 3) {
      cellWidth = docStyles.fullCellLength / 3;
    } else if (maxColArray[index].length === 2) {
      cellWidth = docStyles.fullCellLength / 2;
    }

    autoTable(doc, {
      col,
      rows,
      didParseCell: (data) => {
        const { cell } = data;
        cell.styles.fillColor = [255, 255, 255];
        if (cell.section.includes('body') && cell.raw.length > 30) {
          cell.styles.cellPadding = { top: 15, bottom: 15 };
        }
      },
      showHead: 'firstPage',
      styles: {
        textColor: docStyles.colorText,
        font: docStyles.fontFamily.time,
        ...docStyles.tableStyles,
      },
      headStyles: {
        fontSize: docStyles.textSize,
        textColor: docStyles.colorGreen,
        fontStyle: 'normal',
      },
      columnStyles: {
        col1: {
          fontStyle: docStyles.fontFamily.time,
          textColor: docStyles.colorText,
          cellWidth: cellWidth,
        },
        col2: {
          fontStyle: docStyles.fontFamily.time,
          textColor: docStyles.colorText,
          cellWidth: cellWidth,
        },
        col3: {
          fontStyle: docStyles.fontFamily.time,
          textColor: docStyles.colorText,
          cellWidth: cellWidth,
        },
      },
      startY: finalY,
    });
    return null;
  });
};

export default dataSourceVerificationResults;
